<template>
  <div id="app">
    <Navbar id="nav"></Navbar>
    <Burger id="burguer"></Burger>
    <!-- <LoadPage /> -->
    <span v-if="scrolledToBottom == false"
      ><SocialMedia id="socialMedia"></SocialMedia
    ></span>
    <transition name="fade" mode="out-in">
      <router-view> </router-view>
    </transition>
  </div>
</template>
<script>
import Navbar from "../src/components/Navbar";
/* import Footer from "../src/components/Footer"; */
/* import LoadPage from "@/components/LoadPage"; */
import SocialMedia from "../src/components/SocialMedia.vue";
import Burger from "../src/components/Burger";
export default {
  name: "app",
  components: {
    Navbar,
    /* Footer, */
    SocialMedia,
    Burger,
    /* LoadPage, */
  },
  data: function() {
    return {
      scrolledToBottom: false,
    };
  },
  methods: {
    scroll() {
      window.onscroll = () => {
        console.log("scrool");
        let bottomOfWindow =
          Math.max(
            window.pageYOffset,
            document.documentElement.scrollTop,
            document.body.scrollTop
          ) +
            window.innerHeight ===
          document.documentElement.offsetHeight;

        if (bottomOfWindow) {
          this.scrolledToBottom = true; // replace it with your code
        } else {
          this.scrolledToBottom = false;
        }
      };
    },
  },
  mounted() {
    this.scroll();
  },
};
</script>
<style scoped>
#burguer {
  display: none;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease;
}
@media screen and (max-width: 1000px) {
  #nav {
    display: none;
  }
  #burguer {
    display: flex;
  }
}

@media screen and (max-width: 1000px) {
  #socialMedia {
    display: none;
  }
}
</style>
